import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { CategoryProvidersPageRoutingModule } from './category-providers-routing.module';
import { CategoryProviderComponent } from './category-provider.component';
import { BillerSharedModule } from '../shared/biller-shared.module';
import { SharedModule } from 'src/app/shared/shared.module';
import { ServiceFormComponent } from './service-form/service-form.component';
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    CategoryProvidersPageRoutingModule,
    BillerSharedModule,
    SharedModule
  ],
  declarations: [CategoryProviderComponent, ServiceFormComponent]
})
export class CategoryProvidersModule {}
